import { defineStore } from "pinia";
import {computed, Ref, ref, watch} from "vue";
import { AxiosResponse, AxiosStatic } from "axios";
import { app } from "@/main";
import { catalogoApi } from "@/requests/catalogo";
import { ICatalogoIstanze } from "@/interfaces/response/catalogoIstanze/ICatalogoIstanze";
import { IModulisticaList } from "@/interfaces/response/modulistica/IModulisticaList";
import { NavScrollContentTypes } from "@/enums/components/contents/navScrollContentTypes";
import { IDownload, INavScrollContent, IService, ITextItem } from "cdp-fe-commons-layout";
import { TipoTitolare } from "@/enums/utenti/TipoTitolare";
import { IModulistica } from "@/interfaces/response/modulistica/IModulistica";
import { useRouter } from "vue-router";

export const useServiceDetailStore = defineStore("serviceDetail", () => {

  const router = useRouter();

  //State
  const serviceDetailInfo = ref<IService>();
  const serviceDetail = ref<INavScrollContent<any>[]>([]);

  // Reactive state for language
  const language = ref<string>(localStorage.getItem('locale') || 'it');

  //getters
  const serviceDetailInfoData = computed<Ref<IService | undefined>>(() => serviceDetailInfo);
  const serviceDetailData = computed<Ref<INavScrollContent<any>[]>>(() => serviceDetail);

  // Watcher to save language changes to localStorage
  watch(language, (newLanguage) => {
    localStorage.setItem('locale', newLanguage);
  });




  //Actions
  async function requestServiceDetail(codiceCatalogo: string) {
    const axios: AxiosStatic = app.config.globalProperties.$axios;
    axios.get<ICatalogoIstanze>(catalogoApi.GET_CATALOGO_ISTANZE_BY_CODICE(codiceCatalogo))
      .then(async (el: AxiosResponse<ICatalogoIstanze>) => {
        console.log('el.data',el.data)
        const catalogo = el.data;

        if (!catalogo.pubblicato) {
          router.replace("/");
        } else {
          const modulistica: AxiosResponse<IBaseResponse<IModulisticaList>> = await axios.get<IBaseResponse<IModulisticaList>>(catalogoApi.GET_ALL_MODULISTICA_BY_CATALOGO_ID(catalogo.catalogoId));
          const serviceDetailList: INavScrollContent<any>[] = (JSON.parse(catalogo.descrizione) as INavScrollContent<any>[]).filter((el: INavScrollContent<any>) => {
            //TODO: Forzatura rimovibile cambiando la logica su catalogo_fe, non dovrebbe arrivare un item senza descrizione
            return !("description" in el.item) || el.item.description.length > 0;
          });
          if (modulistica.status === 200 && modulistica.data._embedded?.modulistica?.length > 0) {
            let size = "0 KB";
            modulistica.data._embedded?.modulistica?.forEach((m: IModulistica) => {
              size = JSON.parse(m.metadati).size;
            });
            let description: string = "Questo servizio dispone di alcuni moduli in allegato che puoi scaricare " + size;
            let descriptionEn: string = "This service has some attached forms that you can download " + size;
            serviceDetailList.push({
              title: "Modulistica",
              titleEn: "Forms",
              type: NavScrollContentTypes.TEXT,
              item: { description: description,descriptionEn:descriptionEn } as ITextItem,
              downloadUrls: {
                url: catalogoApi.DOWNLOAD_MODULISTICA_BY_CATALOGO_ID(catalogo.catalogoId),
                filename: "modulistica-allegati"
              } as IDownload
            } as unknown as INavScrollContent<any>);
          }
          serviceDetail.value = serviceDetailList;

          serviceDetailInfo.value = {
            id: catalogo.catalogoId,
            title: catalogo.titolo ?? "",
            titleEn:catalogo.titoloEn ?? "",
            description: catalogo.descrizioneBreve,
            descriptionEn:catalogo.descrizioneBreveEn,
            dataInizioPresentazione: catalogo.presentazioneInizio,
            dataFinePresentazione: catalogo.presentazioneFine,
            pubblicato: catalogo.pubblicato,
            inviabile: catalogo.inviabile,
            argomento: catalogo.descrizioneArgomento,
            routeLink: "/servizi/dettaglio/" + catalogo.codiceCdp,
            svgMaterie: catalogo.svgMateria,
            argomentoRoute: '/argomento/' + catalogo.argomentiId // Adjust path or ID as needed
          } as IService;
        }
      });
  }

  async function getServiceType(catalogoId: string): Promise<TipoTitolare | undefined> {
    const axios: AxiosStatic = app.config.globalProperties.$axios;
    return axios.get(catalogoApi.GET_DESTINATARI_BY_CATALOGO_ID(), { params: { "catalogoId": catalogoId } }).then(
      (destinatari: AxiosResponse<IBaseResponse<ICatalogoDestinatariList>>) => {
        //let cittadino: boolean = destinatari.data._embedded.catalogoDestinatari.some((d: ICatalogoDestinatari) => d.descrizioneDestinatario === "Cittadino");
        //let impresa: boolean = destinatari.data._embedded.catalogoDestinatari.some((d: ICatalogoDestinatari) => d.descrizioneDestinatario !== "Cittadino");
        //if (cittadino && !impresa) {
          return TipoTitolare.PERSONA_FISICA;
       // }
        //if (!cittadino && impresa) {
         // return TipoTitolare.PERSONA_GIURIDICA;
       // }

        //TODO sempre persone fisiche su CDP UNIGE
        return undefined;
      }
    ).catch((reason: any) => {
      console.log(reason);
      return undefined;
    });
  }

  // Function to update language
  function setLanguage(newLanguage: string) {
    language.value = newLanguage;
  }

  return {
    language,
    //Getters
    serviceDetailInfoData, serviceDetailData, getServiceType,
    //Actions
    requestServiceDetail,
    setLanguage
  };
});
